import styled from "styled-components";

const FavoriteDisplay = styled.div`
  @media (min-width: 769px) {
    width: 90vw;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: center;
  }
  margin-bottom: 80px;
`;

export default FavoriteDisplay;
